import { render } from "./PresentacionView.vue?vue&type=template&id=1517bfd2"
import script from "./PresentacionView.vue?vue&type=script&lang=js"
export * from "./PresentacionView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__